export type ListViewMode = 'tile' | 'table';

export type ListViewEntityKey =
    | 'product'
    | 'form'
    | 'property'
    | 'recipe'
    | 'preference-item'
    | 'preference-phrase'
    | 'preference-group';

const storageKey = (entityKey: ListViewEntityKey) => `admin.listView.${entityKey}`;

export const getListViewMode = (
    entityKey: ListViewEntityKey,
    defaultMode: ListViewMode = 'table',
): ListViewMode => {
    try {
        const raw = localStorage.getItem(storageKey(entityKey));
        if (raw === 'tile' || raw === 'table') {
            return raw;
        }
    } catch {
        // ignore quota / private mode
    }
    return defaultMode;
};

export const setListViewMode = (entityKey: ListViewEntityKey, mode: ListViewMode): void => {
    try {
        localStorage.setItem(storageKey(entityKey), mode);
    } catch {
        // ignore quota / private mode
    }
};
